// extracted by mini-css-extract-plugin
export default {"button":"style__button___ChGeZ","image":"style__image___Yxji9","label":"style__label___fKWs8"};